import { FC } from 'react';

type Props = {
  location: string;
};

const LocationBadge: FC<Props> = ({ location }) => {
  return (
    <span className='text-muted fw-bold text-muted d-block fs-7'>
      <i className='bi bi-geo'></i> {location}
    </span>
  );
};

export default LocationBadge;
